module.exports = __webpack_public_path__ + "img/esmeralda-pool-3.419ba75a.jpg";